import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const ECOMBundleReceiptEntry = () => {
  return (
    <SectionBundleReceiptEntry
      sectionName="ECOM"
      sectionDisplayName="ECOM Section"
      backRoute="/sections/ecom"
    />
  );
};

export default ECOMBundleReceiptEntry;
